import api from '../../api';
import config from '../../config';
export default {
    post: (data) => {
        return api.request('post',config.default.userDetailsByEmail, null, null, data)
    }
}